export function initFixedHeader() {
  // Sepet sidebar
  const cartBox = document.querySelector('.cart-box');
  const cartSidebar = document.getElementById('cartSidebar');
  const cartClose = document.getElementById('cartClose');
  const overlay = document.getElementById('overlay');

  if (cartBox && cartSidebar && cartClose && overlay) {
    cartBox.addEventListener('click', () => {
      cartSidebar.classList.add('open');
      overlay.classList.add('active');
    });

    cartClose.addEventListener('click', () => {
      cartSidebar.classList.remove('open');
      overlay.classList.remove('active');
    });

    overlay.addEventListener('click', () => {
      cartSidebar.classList.remove('open');
      overlay.classList.remove('active');
      const menuSidebar = document.getElementById('menuSidebar');
      if (menuSidebar) menuSidebar.classList.remove('open');
    });
  }

  // Mobil menü sidebar
  const mobileMenuBtn = document.getElementById('mobileMenuBtn');
  const menuSidebar = document.getElementById('menuSidebar');
  const menuClose = document.getElementById('menuClose');

  if (mobileMenuBtn && menuSidebar && menuClose && overlay) {
    mobileMenuBtn.addEventListener('click', () => {
      menuSidebar.classList.add('open');
      overlay.classList.add('active');
    });

    menuClose.addEventListener('click', () => {
      menuSidebar.classList.remove('open');
      overlay.classList.remove('active');
    });
  }

  // Scroll ile bottom-nav fixed
  const bottomNav = document.querySelector('.bottom-nav');
  if (bottomNav) {
    const originalOffset = bottomNav.offsetTop;

    window.addEventListener('scroll', () => {
      if (window.scrollY > originalOffset) {
        bottomNav.classList.add('fixed');
        document.body.classList.add('has-fixed-nav');
      } else {
        bottomNav.classList.remove('fixed');
        document.body.classList.remove('has-fixed-nav');
      }
    });
  }
}


// WEBPACK FOOTER //
// ./src/static/js/global.js